export const visitorProfileRefs = (is_enabled: boolean) => {
  return [
    { refValue: 'first_name', title: 'Όνομα' },
    { refValue: 'last_name', title: 'Επώνυμο' },
    { refValue: 'email', title: 'Email' },
    { refValue: 'phone_number', title: 'Τηλέφωνο' },
    { refValue: 'auth', title: 'Authentication method' },
    { refValue: 'afm', title: 'ΑΦΜ' },
    { refValue: 'date_created', title: 'Ημ. Δημιουργίας' },
    { refValue: 'date_deleted', title: 'Ημ. Διαγραφής' },
    { refValue: 'status', title: 'Κατάσταση' },
    ...(!is_enabled
      ? [{ refValue: 'disable_reason', title: 'Λόγος Αποκλεισμού' },]
      : []
    ),
    { refValue: 'category', title: 'Κατηγορία Χρήστη' },
    { refValue: 'roles', title: 'Επιπλέον Ρόλοι' },
  ];
}; 